import * as React from 'react';

type ModuleEditAccessContextType = {
  canEdit: boolean;
  canEditOnModule: (module: string) => boolean;
};

export const ModuleEditAccessContext = React.createContext<ModuleEditAccessContextType>({
  canEdit: false,
  canEditOnModule: () => false,
});

type Props = {
  module: string;
  children: JSX.Element;
  hasEditFunctionality: (module: string) => boolean;
};

export const ModuleEditAccessProvider: React.FunctionComponent<Props> = ({
  module,
  hasEditFunctionality,
  children,
}) => (
  <ModuleEditAccessContext.Provider
    value={{
      canEdit: hasEditFunctionality(module),
      canEditOnModule: hasEditFunctionality,
    }}
  >
    {children}
  </ModuleEditAccessContext.Provider>
);
